import { PriceModel } from '@loavies/c2c-models'

/**
 * @param {Object} price
 * @returns {loavies.models.base.PriceModel}
 */
export function mapPrice(price) {
  return new PriceModel({
    amount: price ? price.amount : 0,
    currency: price ? price.currency : 'EUR',
  })
}
